/* eslint-disable @typescript-eslint/no-magic-numbers */
export const MS_IN_SEC = 1000;
export const MS_IN_MINUTE = 60000;
export const MS_IN_DAY = 1000 * 60 * 60 * 24;
